import { useEffect, useState } from 'react'
import { DashboardGroup } from 'experiences/dashboard/DashboardRoot'
import { buildDefaultDashItem, StaticContent } from 'experiences/dashboard/DashboardRoot/cards'
import { ID } from 'lib'
import { useAuth } from 'services/Authentication'
import { buildDashGroup } from 'experiences/dashboard/DashboardRoot/lib/types'

const buildWelcomeGroup = (daysSinceSignup?: number) => {
	if (daysSinceSignup && daysSinceSignup < 30) {
		return buildDashGroup(StaticContent.WelcomeContent)
	} else {
		return buildDashGroup(StaticContent.NewSearch)
	}
}

export const useWelcomeGroup = () => {
	const [group, setGroup] = useState<DashboardGroup>({
		key: ID('welcome'),
		items: [buildDefaultDashItem()]
	})
	const { state: authState, userInfo } = useAuth()
	useEffect(() => {
		if (authState === 'authenticated') {
			const daysSinceSignup = userInfo.profile.daysSinceSignup
			setGroup(buildWelcomeGroup(daysSinceSignup))
		}
	}, [authState, userInfo])
	return group
}
